module.exports = __webpack_public_path__ + "static/media/places_pages_final.45ea83bb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/places_pages_final.gif
// module id = 182
// module chunks = 0